export default __webpack_public_path__ + "static/media/Vivek.aaa36c95.png";